<template>
  <div class="am3-optin-panel">
    <div v-if="showPanel" class="am3-optin-panel__content">
      <div class="panel-header">
        <div class="early-access-badge">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-4">
            <path fill-rule="evenodd" d="M11 3.5v2.257c0 .597.237 1.17.659 1.591l2.733 2.733c.39.39.608.918.608 1.469a2.04 2.04 0 0 1-1.702 2.024C11.573 13.854 9.803 14 8 14s-3.573-.146-5.298-.426A2.04 2.04 0 0 1 1 11.55c0-.551.219-1.08.608-1.47l2.733-2.732A2.25 2.25 0 0 0 5 5.758V3.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5H11ZM6.5 5.757V3.5h3v2.257a3.75 3.75 0 0 0 1.098 2.652l.158.158a3.36 3.36 0 0 0-.075.034c-.424.2-.916.194-1.335-.016l-1.19-.595a4.943 4.943 0 0 0-2.07-.52A3.75 3.75 0 0 0 6.5 5.757Z" clip-rule="evenodd" />
          </svg>


          EARLY ACCESS
        </div>

        <div class="close-button" @click="togglePanel">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </div>
      </div>


      <div class="opt-in-text">
        <h2 class="text-2xl font-bold mb-4" style="margin-bottom: 1rem;">Try the new Audience Manager</h2>
        <p style="margin-bottom: 0.5rem;">Experience a faster, smarter way to manage your audience — before it's officially released.</p>
        <p style="margin-bottom: 0;">You can switch back to the classic view anytime from your Settings.</p>
      </div>


      <!-- <ar-simple-button
        text="Join Early Access"
        type="purple"
        @click="handleOptIn"
        class="am3-optin-panel__button"
        size="sm"
      /> -->
      <div class="u-display-flex u-flex-flow-row u-align-items-center switch-container">
        <p>Try the new look</p>
        <am2-switch
            :value="isEarlyAccessEnabled"
            @input="updateToggleState"
        />
      </div>

    </div>

    <button
      @click="togglePanel"
      class="am3-optin-panel__trigger-button"
    >
      <!-- Beaker icon from heroicons -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-4">
        <path fill-rule="evenodd" d="M11 3.5v2.257c0 .597.237 1.17.659 1.591l2.733 2.733c.39.39.608.918.608 1.469a2.04 2.04 0 0 1-1.702 2.024C11.573 13.854 9.803 14 8 14s-3.573-.146-5.298-.426A2.04 2.04 0 0 1 1 11.55c0-.551.219-1.08.608-1.47l2.733-2.732A2.25 2.25 0 0 0 5 5.758V3.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5H11ZM6.5 5.757V3.5h3v2.257a3.75 3.75 0 0 0 1.098 2.652l.158.158a3.36 3.36 0 0 0-.075.034c-.424.2-.916.194-1.335-.016l-1.19-.595a4.943 4.943 0 0 0-2.07-.52A3.75 3.75 0 0 0 6.5 5.757Z" clip-rule="evenodd" />
      </svg>

    </button>

  </div>
</template>

<script>
import { getCookie, setCookie } from '../../../utils/cookie.js';

export default {
  name: 'am3-optin-panel',

  data() {
    return {
      showPanel: false,
      isEarlyAccessEnabled: false
    };
  },

  mounted() {
    this.checkOptInStatus();
  },

  methods: {
    checkOptInStatus() {
      const optInCookie = getCookie('am3EarlyAccessOptIn');

      // Check if user has enabled early access and update the switch state
      this.isEarlyAccessEnabled = optInCookie === 'true';

      // Show full panel if user hasn't opted in or out yet
      if (optInCookie !== 'true' && optInCookie !== 'false') {
        this.showPanel = true;
      } else {
        // Show button if user has opted in or out
        this.showPanel = false;
      }
    },

    togglePanel() {
      // Toggle the panel visibility when the button is clicked
      this.showPanel = !this.showPanel;
    },

    updateToggleState(value) {
      this.isEarlyAccessEnabled = value;

      // Set cookie for opt-in based on toggle value
      setCookie('am3EarlyAccessOptIn', value ? 'true' : 'false', {
        path: '/',
        // No maxAge (permanent)
      });

      window.location.reload(); // reload once the cookie is set
      
      // Close the panel after a short delay
      setTimeout(() => {
        this.showPanel = false;
      }, 500);
    },

    handleOptIn() {
      // Set cookie for opt-in
      setCookie('am3EarlyAccessOptIn', 'true', {
        path: '/',
        // No maxAge (permanent)
      });

      // Update toggle state
      this.isEarlyAccessEnabled = true;

      // Hide panel after opt-in
      this.showPanel = false; 
    }
  }
};
</script>

<style lang="scss" scoped>

.am3-optin-panel__trigger-button {
  border-radius: 100%;
  background-color: #edf1f5;
  margin: 0 auto 8px;
  max-width: 36px;
  max-height: 36px;
  width: 100%;
  height: 100%;
  min-height: 36px;
  border: 0;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    color: #8e97a6;
    &:hover {
      color:  #9333EA ;
    }
  }
  &:hover {
    color:  #9333EA ;
  }
}

.am3-optin-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // margin-bottom: 16px;
  box-sizing: border-box;

  @media screen and (max-width: 767px ) {
    // display: none ;
    flex-direction: row;
    align-items: baseline;
    justify-content: start ;
    font-size: 1rem;
    button  {
      margin-left: 0;
      margin-right: 10px ;
    }
  }

  &__content {
    position: absolute;
    left: 100px;
    top: auto;
    border-radius: 8px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: start;
    background-color: #fff;
    box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1),
                0px 10px 15px -3px rgba(0, 0, 0, 0.1),
                0px 0px 0px 1px rgba(0, 0, 0, 0.05);
    width: 480px;
    z-index: 1000;


    @media screen and (max-width: 767px ) {
      top: auto;
      left: 90px;
      position: fixed;
      bottom: 1rem;
    }

    @media screen and (max-height: 767px ) {
      top: auto;
      left: 90px;
      position: fixed;
      bottom: 1rem;
    }


  }

  &__title {
    margin: 8px 0;
  }

  &__button {
    width: 100%;
    margin-top: 8px;
  }

  &__trigger-button {
    width: 100%;
    margin-bottom: 1rem;


    .beaker-icon {
      // width: 16px;
      // height: 16px;
    }
  }

  .switch-container > p {
    margin-right: 16px;
  }

  .panel-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .close-button {
      cursor: pointer;
      color: #6B7280;

      svg {
        width: 20px;
        height: 20px;
      }

      &:hover {
        color: #1F2937;
      }
    }
  }

  .early-access-badge {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    background-color: #F4F0FA;
    color: #9333EA;
    font-size: 10px;
    font-weight: bold;
    border-radius: 8px;

    > svg {
      margin-right: 4px;
      width: 12px;
      height: 12px;
    }
  }

  .opt-in-text {
    h2 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      color: #4B5563;
      line-height: 1.4;
    }
  }
}

</style>
